// Feedback client — thumbs up/down and free-text corrections. Both
// endpoints require auth and are logged server-side in audit_log.

import { api } from './api';

export interface RatingRequest {
  conversation_id: string;
  message_id: string;
  rating: 1 | -1;
  comment?: string;
}

export interface RatingResponse {
  id: string;
  rating: 1 | -1;
  comment?: string;
  updated_at: string;
}

/** Submit 👍 / 👎 on an assistant message. Upsert — second call updates. */
export async function submitRating(req: RatingRequest): Promise<RatingResponse> {
  const { data } = await api.post<RatingResponse>('/api/v1/feedback/rating', req);
  return data;
}

export interface CorrectionRequest {
  message_id?: string;
  workbook_hash?: string;
  ai_output: string;
  corrected_output: string;
  correction_type?: string;
}

export interface CorrectionResponse {
  id: string;
  message_id: string | null;
  created_at: string;
}

/** Submit a "AI said X, should be Y" correction. Append-only. */
export async function submitCorrection(req: CorrectionRequest): Promise<CorrectionResponse> {
  const { data } = await api.post<CorrectionResponse>('/api/v1/feedback/correction', req);
  return data;
}
